import { SubmitToLabsWebComponent } from './component/SubmitToLabsWebComponent';
import { WEB_COMPONENT_SUBMIT_TO_LABS } from '../../../webcomponents.constants';

export { SubmitToLabsWebComponent };

window.customElements.define(WEB_COMPONENT_SUBMIT_TO_LABS, SubmitToLabsWebComponent);
